import { render, staticRenderFns } from "./OnboardingModalWrapper.vue?vue&type=template&id=a7273d30"
import script from "./OnboardingModalWrapper.vue?vue&type=script&lang=js"
export * from "./OnboardingModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports